import React from 'react';
import cx from 'classnames';
import { Card } from 'reactstrap';

const Testimonial = ({
  children,
  image,
  speakerName,
  title,
  workplace,
  right = false,
}) => {
  return (
    <Card className={cx('testimonial bg-light-purple rounded p-4 mb-2')}>
      <blockquote>{children}</blockquote>
      <div className="d-flex align-items-center">
        {!right && (
          <div className="mr-2 d-none d-sm-block" aria-hidden>
            {image}
          </div>
        )}
        <cite className={cx('small w-100', { 'text-right': right })}>
          <p className="font-weight-bold mb-0">{speakerName}</p>
          <p>
            {title}, {workplace}
          </p>
        </cite>
        {right && (
          <div className="ml-2 d-none d-sm-block" aria-hidden>
            {image}
          </div>
        )}
      </div>
    </Card>
  );
};

export default Testimonial;
